import { render } from "./ZoomOutIcon.vue?vue&type=template&id=74fcab1a"
import script from "./ZoomOutIcon.vue?vue&type=script&lang=js"
export * from "./ZoomOutIcon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__